import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Encryption } from '../../services/encryption.service';

@Injectable({
	providedIn: 'root',
})
export class CustomMatRangeService extends NativeDateAdapter {
	getFirstDayOfWeek(): number {
		return Encryption.getLsValue<string>('lang') === 'ru' || Encryption.getLsValue<string>('lang') === null ? 1 : 0;
	}
}
